import React, { ReactNode } from 'react'

import classNames from 'classnames'
import { RadioCard } from './RadioCard'
import { ContentType, TrialLessonArea } from '../../types/trialLessons'

type OptionSpec = {
  label: string
  recommendLabel: string
  sheGirl: string
  headerText: string
  description?: ReactNode
  badge?: string
  value: string
  htmlDataValue?: string
  isRecommended?: boolean
}

type SingleProps = {
  options: OptionSpec[]
  value?: string | null
  widthType?: 's' | 'm' | 'l'
  onChange: (value: any) => void
  className?: string
  styleName?: string
  contentType: ContentType
  arrangementType?: 'horizon' | 'vertical'
  gaSendEventCategory?: string
  gaSendEventEventName?: string
  addGaSendEventEventNameDetail?: boolean
}

export const CheckBoxCardSelectInput = ({
  value,
  options,
  onChange,
  widthType = 'l',
  arrangementType = 'vertical',
  contentType,
  gaSendEventCategory,
  gaSendEventEventName,
  addGaSendEventEventNameDetail,
}: SingleProps) => {
  return (
    <div className="flex justify-start gap-4 sp:flex-col sp:gap-[35px]">
      {options.map((o, i) => (
        <div
          key={String(o.value)}
          className={classNames('relative pt-[75px] px-4 pb-4', {
            'bg-pink-light sp:pb-6': contentType === 'normal' && i === 0,
            'bg-[#f0f6f7] sp:pb-6': contentType === 'normal' && i === 1,
          })}
        >
          {i === 0 && (
            <img
              className="absolute w-[153px] -top-[14px] left-[100px]"
              src={o.recommendLabel}
              alt=""
            />
          )}
          <div
            className={classNames(
              'w-[90%] sp:w-[93%] flex items-center gap-[6px] absolute -top-5',
              {
                'sp:flex-row-reverse': i === 1,
              }
            )}
          >
            <img className="w-20 h-20 m-0" src={o.sheGirl} alt="" />
            <p className="font-europa text-xs font-bold text-left leading-4 tracking-[1.6px] mt-10">
              {o.headerText}
            </p>
          </div>
          <RadioCard
            checked={o.value === value}
            className="relative p-[15px] desktop:mb-4 desktop:last:mb-0 sp:mb-8 sp:last:mb-0"
            label={o.label}
            onCheck={checked => {
              onChange(checked ? (o.value as TrialLessonArea) : null)
              // TODO implement GA
              // gaSendEventCategory &&
              // gaSendEventEventName &&
              // GoogleAnalyticsClient.sendGaEvent(
              //   gaSendEventCategory,
              //   addGaSendEventEventNameDetail ? gaSendEventEventName + '_' + o.value : gaSendEventEventName
              // );
            }}
            data-value={o.htmlDataValue}
            description={o.description}
          />
        </div>
      ))}
    </div>
  )
}
